import {
  formItemTypeEnum,
  matchModeEnum,
  operatorEnum,
} from '@sttedra_ui/framework';

const checkboxProperties = {
  binary: true,
  truValue: true,
  falseValue: false,
};
const customChipClassification = (f) => !!f.value ? 'verdadero' : 'falso';

export const TOWNS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
  {
    field: 'population',
    label: 'Nº Habitantes',
    classObj: ['query__header--align-right'],
  },
  {
    field: 'area',
    label: 'Superficie (km2)',
    classObj: ['query__header--align-right'],
  },
  {
    field: 'height',
    label: 'Altitud (m)',
    classObj: ['query__header--align-right'],
  },
];

export const TOWNS_FILTERS = [
  {
    field: 'popPlus25k',
    label: 'Más de 25.000 habitantes',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
    ],
  },
  {
    field: 'pop5kto25k',
    label: 'Entre 5.000 y 25.000 habitantes',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
    ],
  },
  {
    field: 'pop1kto5k',
    label: 'Entre 1.000 y 5.000 habitantes',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
    ],
  },
  {
    field: 'popMinus1k',
    label: 'Menos de 1.000 habitantes',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
    ],
  },
];
